export interface Analytics {
  trackClick: (area?: ApplicationArea | string) => void;
}

export enum ApplicationArea {
  'TabPanel' = 'Sliding Menu',
  'TabPanel.Tickets' = 'Sliding Menu / Tickets',
  'TabPanel.Phone' = 'Sliding Menu / Phone',
  'TabPanel.Chat' = 'Sliding Menu / Chat',
  'TabPanel.Tickets.ServiceNow' = 'Sliding Menu / Tickets / ServiceNow Link',
  'Header.Logo' = 'Top Bar / Deloitte',
  'Header.Info' = 'Top Bar / Information icon',
  'Header.Countries' = 'Top Bar / Countries',
  'Header.Search' = 'Top Bar / Homepage Search',
  'Header.Notification' = 'Top Bar / Notification',
  'Header.Profile' = 'Top Bar / Profile',
  'HomePage.Search' = 'Homepage Search',
  'GlobalSearch.Chat' = 'Homepage Search / Chat',
  'GlobalSearch.Phone' = 'Homepage Search / Phone',
  'Chat' = 'Chat',
  'Phone' = 'Phone',
  'Search' = 'Homepage Search',
  'Share' = 'Share',
  'Copy' = 'Copy',
  'Email' = 'Email',
  'Feedback' = 'Feedback',
  'Carousel' = 'Carousel',
  'Carousel.Navigate' = 'Carousel / Navigate Buttons',
  'About.Video' = 'Welcome SolveIt Video',
  'SolutionArticle.Video' = 'Play Video'
}

export enum PortalUrl {
  article = 'article'
}
